import { Stack } from '@mui/material';

import { useFooter } from 'queries/global/useFooter';

import Link from 'components/@common/Link';
import Icon from 'components/@icons/Icon';

import { mapSocialLinks } from './utils';

const Socials = () => {
  const { socialLinks } = useFooter();
  const socials = mapSocialLinks(socialLinks);

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyContent: { xs: 'space-evenly', md: 'flex-end' },
        flexWrap: 'wrap',
        gap: 1,
        flex: '1 0 0',
      }}
    >
      {socials.map(({ key, iconName, href }) => (
        <Link
          key={key}
          href={href}
          target="_blank"
          p={0.5}
          display="flex"
          aria-label={key}
        >
          <Icon name={iconName} color="text.secondary" fontSize={24} />
        </Link>
      ))}
    </Stack>
  );
};

export default Socials;
